import { render } from "./NewPatient.vue?vue&type=template&id=d861748a"
import script from "./NewPatient.vue?vue&type=script&lang=js"
export * from "./NewPatient.vue?vue&type=script&lang=js"

import "./NewPatient.vue?vue&type=style&index=0&id=d861748a&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__